import * as React from 'react';

import BarGraph from '../../../common/DataViz/bar.Component';
import { StyledCard } from './LessonAttempts.styles';


interface IProps {
  data?: any;
}

class LessonAttempts extends React.Component<IProps> {
  public state = {};

  constructor(props) {
    super(props);
  }

  public render() {
    const { data } = this.props;
    const barGraphData = data.Attempts.map((attempt) => {
      return {
        attempt: attempt.AttemptIdentifier,
        score: attempt.Score,
        scoreColor: `#${Math.random().toString(16).substr(2, 6)}`,
      };
    });

    return (
      <StyledCard>
        <h2 className="title">Attempts</h2>
        <BarGraph
          realData={barGraphData}
          indexBy="attempt"
          bottomLabel="Attempt"
          leftLabel="Score"
          labelNoRotate={true}
        />
      </StyledCard>
    );
  }
}

export default LessonAttempts;



// WEBPACK FOOTER //
// ./src/components/DataCentre/LessonAttempts/LessonAttempts.tsx